import React from 'react';
import PropTypes from 'prop-types';
import getCustomIcon from 'lib/seats/getCustomIcon';
import { getAvailableSeatTypes } from 'lib/seats/seatTypes';
import get from 'lodash/get';
import features from 'lib/common/features';

const KeyIcon = props => {
    const seatType = props.seatType;
    if (seatType.method === 'custom') {
        const icon = getCustomIcon(seatType.customName);
        return (icon) ? (
            <svg className="syos-custom-icon" viewBox={`0 0 ${props.customIconSize} ${props.customIconSize}`}>
                <path className={`seat seat--${seatType.slug}`} d={icon.pathData} />
            </svg>
        ) : null;
    } else {
        const defaultKeySize = 18;
        return (
            <svg viewBox={`0 0 ${defaultKeySize} ${defaultKeySize}`}>
                <circle className={`seat seat--${seatType.slug}`}
                    r={defaultKeySize/3} cx={defaultKeySize/2} cy={defaultKeySize/2}></circle>
            </svg>
        )
    }
}
KeyIcon.propTypes = {
    customIconSize: PropTypes.number,
    seatType: PropTypes.shape({
        method: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired
    })
}

const SeatKey = props => {
    const seatTypes = getAvailableSeatTypes();
    const customIconSize = get(props.currentFacility, 'customIconSize', 10);
    return (
        <div className="syos-key">
            <ul className="syos-key__list">
                {seatTypes.map(function(type, idx) {
                    return (
                        <li className="syos-key__list__item" key={idx}>
                            <span className="syos-key__icon">
                                <KeyIcon seatType={type} customIconSize={customIconSize} />
                            </span>
                            <span className="syos-key__label">{type.label}</span>
                        </li>
                    )
                })}
                {features.isEnabled('seatKeyPersistentIcons') && features.getOption('seatKeyPersistentIcons', 'persistentIcons').lenth ? features.getOption('seatKeyPersistentIcons', 'persistentIcons').map((type, idx) => {
                  return (
                      <li className="syos-key__list__item" key={idx}>
                          <span className="syos-key__icon">
                              <KeyIcon seatType={type} customIconSize={customIconSize} />
                          </span>
                          <span className="syos-key__label">{type.label}</span>
                      </li>
                  )
                }) : null}
            </ul>
        </div>
    )
}
SeatKey.propTypes = {
    currentFacility: PropTypes.object,
    isAvailable: PropTypes.bool.isRequired // eslint-disable-line react/no-unused-prop-types
}

export default SeatKey



// WEBPACK FOOTER //
// ./src/javascripts/app/components/SeatKey.js